import { FiChevronsRight, FiTruck } from 'react-icons/fi';
import { FaMoneyBillAlt, FaPaypal, FaStripe } from 'react-icons/fa';

import { CashOnDeliveryPayment } from './CashOnDeliveryPayment';
import { StripePayment } from './StripePayment';
import { PayPalPayment } from './PayPalPayment';
import { WayforpayPayment } from './WayforpayPayment';
import { RobokassaPayment } from './RobokassaPayment';
import { LiqpayPayment } from './LiqpayPayment';
import { OtherPayment } from './OtherPayment';

export const PAYMENT_PROVIDERS = [
    { provider: 'cod', icon: FiTruck },
    { provider: 'paypal', icon: FaPaypal },
    { provider: 'stripe', icon: FaStripe },
    { provider: 'wayforpay', icon: FaMoneyBillAlt },
    // { provider: 'robokassa', icon: FaMoneyBillAlt },
    { provider: 'liqpay', icon: FiChevronsRight },
    // { provider: 'other', icon: FaMoneyBillAlt },
];

export const PAYMENT_PROVIDER_RENDERERS = {
    cod: CashOnDeliveryPayment,
    stripe: StripePayment,
    paypal: PayPalPayment,
    wayforpay: WayforpayPayment,
    robokassa: RobokassaPayment,
    liqpay: LiqpayPayment,
    other: OtherPayment,
};
